export default __webpack_public_path__ + "static/media/Mauritania.787074e5.png";